import { CrossSellOfferTerms } from './creditCardCrossSell.types';

type OfferModalTerms = {
    creditLimit: number;
    apr: number;
    cashbackRate: number;
};

export const getOfferModalProps = (
    offer: CrossSellOfferTerms
): OfferModalTerms => ({
    creditLimit: parseFloat(offer.limit),
    apr: parseFloat(offer.apr),
    cashbackRate: parseFloat(offer.cashback_rate)
});
